
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthActions} from "./AuthAction";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {teacherIdState} from "../../recoil/teacher/teacherIdState";
import {authState} from "../../recoil/auth/authState";
import {getCookie, setCookie} from "../../cookie/Cookie";

const LoginCheck = () => {
    const [teacherId, setTeacherId] = useRecoilState(teacherIdState);


    useEffect(() => {
        const authCookie = getCookie("auth");

        if(authCookie && authCookie.loginStatus === "LOGGED_IN"){
            setTeacherId(authCookie.teacher.teacherId);
        }else{
            window.location.href = `${process.env.REACT_APP_IS_OAUTH2_URL}?serviceId=${process.env.REACT_APP_IS_OAUTH2_SERVICE_ID}&secret=${process.env.REACT_APP_IS_OAUTH2_SECRET}&ld=loginDirect&mode=login&callback_uri=${process.env.REACT_APP_IS_OAUTH2_CALL_BACK_URL}`;
        }
    }, []);

    return (
        <>
        </>
    );
}

export default LoginCheck;